import React, { useEffect, useState } from 'react';
import { loadHomeownerClient } from '../utils/homeownerApi';
import { homeownerGate } from '../shared/consentCopy';
import HomeownerPasswordGate from './HomeownerPasswordGate';
import HomeownerTermsUpdate from './HomeownerTermsUpdate';

/**
 * Invite clickwrap before the password exists. Updated terms block the dashboard
 * until the current version is logged.
 */
export default function HomeownerConsentFlow({ client, onClient, onUnlocked, onLogout }) {
  const [agent, setAgent] = useState(null);
  const [agentLoading, setAgentLoading] = useState(true);
  const [termsAccepted, setTermsAccepted] = useState(null);

  const clientId = client && client.id;
  useEffect(() => {
    let cancel = false;
    setAgentLoading(true);
    loadHomeownerClient()
      .then((data) => {
        if (cancel) return;
        if (data && data.client && onClient) onClient(data.client);
        setAgent(data && data.agent);
        setTermsAccepted(data && data.termsAccepted === true);
      })
      .catch(() => {
        if (cancel) return;
        setAgent(null);
        setTermsAccepted(false);
      })
      .finally(() => {
        if (!cancel) setAgentLoading(false);
      });
    return () => {
      cancel = true;
    };
  }, [clientId, onClient]);

  const current = client;
  const gate = homeownerGate(current, termsAccepted);
  useEffect(() => {
    if (gate === 'app' && onUnlocked) onUnlocked();
  }, [gate, onUnlocked]);
  if (gate === 'loading' || gate === 'app') {
    return (
      <p style={{ padding: '2rem', textAlign: 'center' }}>Loading your account…</p>
    );
  }
  if (gate === 'invite') {
    return (
      <HomeownerPasswordGate
        client={current}
        agent={agent}
        agentLoading={agentLoading}
        onLogout={onLogout}
        onDone={async (next) => {
          if (onClient && next) onClient(next);
          setTermsAccepted(true);
          if (onUnlocked) onUnlocked();
        }}
      />
    );
  }
  return (
    <HomeownerTermsUpdate
      onLogout={onLogout}
      onDone={async () => {
        setTermsAccepted(true);
      }}
    />
  );
}
